import { events } from '@/services/events';
import { ReplacementTags } from '@/store/modules/global/state';
import { formatUrl } from '@/utilities/Url';

export enum RedirectTarget {
  BLANK,
  TOP,
  SELF
}

export interface RedirectItem {
  url: string;
  target: RedirectTarget;
}

export type RedirectEvent = CustomEvent<RedirectItem>;

export const redirect = (item: RedirectItem, extraReplacementTags?: ReplacementTags | undefined) => {
  const formattedUrl = formatUrl(item.url, extraReplacementTags);

  item.url = formattedUrl ?? item.url;

  const event: RedirectEvent = new CustomEvent<RedirectItem>('redirect');
  event.initCustomEvent('redirect', true, true, item);

  events.emit('redirect', event);
  if (event.defaultPrevented) {
    return;
  }

  // Safeguard against javascript.browser.security.open-redirect.js-open-redirect semgrep rule.
  if (item.url.startsWith('javascript:')) {
    throw new Error('Unsafe JavaScript redirect. Rejected.');
  }

  switch (item.target) {
    case RedirectTarget.BLANK:
      // eslint-disable-next-line security/detect-non-literal-fs-filename
      window.open(item.url);
      break;
    case RedirectTarget.SELF:
      window.location.href = item.url; // nosem
      break;
    case RedirectTarget.TOP:
      window.top.location.href = item.url;
      break;
  }
};
